module.exports = __webpack_public_path__ + "static/media/ipad_rounded_corners_700x290.dad31330.png";